import * as React from 'react';

import classNames from 'classnames';

interface IControlProps {
	title?: string;
	className?: string;
	hasIconsLeft?: boolean;
	hasIconsRight?: boolean;
	isLoading?: boolean;
	isExpanded?: boolean;
	onClick?: () => void;
}

export default class Control extends React.Component<IControlProps, {}> {
	public render() {
		const {
			className,
			hasIconsLeft,
			hasIconsRight,
			isLoading,
			isExpanded,
			onClick,
			title,
		} = this.props;

		const classes = classNames(
			'control',
			className ? className : '',
			hasIconsLeft ? 'has-icons-left' : '',
			hasIconsRight ? 'has-icons-right' : '',
			isLoading ? 'is-loading' : '',
			isExpanded ? 'is-expanded' : ''
		);

		return (
			<div className={classes} onClick={onClick} title={title}>
				{this.props.children}
			</div>
		);
	}
}
